import { render } from "./BoxScore.vue?vue&type=template&id=171d5f3f&scoped=true"
import script from "./BoxScore.vue?vue&type=script&lang=js"
export * from "./BoxScore.vue?vue&type=script&lang=js"

import "./BoxScore.vue?vue&type=style&index=0&id=171d5f3f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171d5f3f"]])

export default __exports__